module.exports = __webpack_public_path__ + "i18n/ru_26b4ae47379b7323000aa1cd58731d82.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 154